import React, { useState, useEffect } from "react";
import * as XLSX from "xlsx";
import { postCalendarData } from "reducer/trainingCalendarSlice";
import { useDispatch, useSelector } from "react-redux";
import { Button, Checkbox, FormControlLabel, Typography } from "@mui/material";
import { appendEmptyStrings, parseFlexibleDate } from "helpers/common";

export default function UploadTrainingForm() {
  const [jsonData, setJsonData] = useState(null);
  const [fileLoaded, setFileLoaded] = useState(false);
  const [operationType, setOperationType] = useState("add");
  const [msg, setMsg] = useState(null);
  const dispatch = useDispatch();
  const postStatus = useSelector((state) => state.calendarSlice.postStatus);
  const error = useSelector((state) => state.calendarSlice.error);

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();
  
    reader.onload = (event) => {
      const fileData = event.target.result;
      const workbook = XLSX.read(fileData, { type: "binary" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const json = XLSX.utils.sheet_to_json(worksheet, {
        raw: false, // Ensures dates are read as strings
      });  
      const requiredColumns = ["Training", "Description", "startDate_YYYY-MM-DD", "endDate_YYYY-MM-DD"];
      const missingColumns = requiredColumns.filter(col => !json[0]?.hasOwnProperty(col));
  
      if (missingColumns.length > 0) {
        setMsg(`Missing required columns: ${missingColumns.join(", ")}`);
        return;
      }
  
      for (let i = 0; i < json.length; i++) {
        for (const col of requiredColumns) {
          if (!json[i][col]) {
            setMsg(`Error: Row ${i + 1} has empty "${col}" field.`);
            return;
          }
        }
      }
      console.log("JSON",json)
      const formattedJson = json.map((row) => {
        row.start = parseFlexibleDate(row["startDate_YYYY-MM-DD"]); 
        row.end = parseFlexibleDate(row["endDate_YYYY-MM-DD"]);
        row.Description = appendEmptyStrings(row)
        return row;
      });
      console.log("formattedJson",formattedJson)
      setJsonData(formattedJson);
      setFileLoaded(true);
      setMsg(null);
    };
  
    reader.readAsBinaryString(file);
  };
  

  const handleUpload = () => {
    if (jsonData) {
      dispatch(postCalendarData({ data: jsonData, action: operationType }));
    }
  };

  useEffect(() => {
    if (postStatus === "success") {
      setMsg("Data uploaded successfully!");
      setJsonData(null);
      setFileLoaded(false);
    } else if (postStatus === "failed") {
      setMsg(`Failed to upload data: ${error}`);
    }
    return () => setMsg(null);
  }, [postStatus, error]);

  return (
    <div style={{ margin: "20px", maxWidth: "500px" }}>
              {msg && <Typography color="error">{msg}</Typography>}
      <a
        href="/assets/FormattedSamplexlsx.xlsx"
        download
        style={{ fontSize: "16px", fontWeight: "bold", color: "blue", textDecoration: "none" }}
      >
        Download Template
      </a>
      <Typography variant="h6" style={{ marginTop: "10px" }}>Upload XLSX File</Typography>
      <input type="file" accept=".xlsx" onChange={handleFileUpload} style={{ marginBottom: "10px" }} />

      <div style={{ display: "flex", flexDirection: "row", gap: "10px" }}>
        <FormControlLabel
          control={
            <Checkbox
              checked={operationType === "add"}
              onChange={() => setOperationType("add")}
            />
          }
          label="Add Events"
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={operationType === "delete"}
              onChange={() => setOperationType("delete")}
            />
          }
          label="Delete Events"
        />

        {fileLoaded && (
          <Button variant="contained" color="primary" onClick={handleUpload}>
            Upload
          </Button>
        )}
        {postStatus === "loading" && <Typography>Uploading data...</Typography>}
      </div>
    </div>
  );
}